/************************************************************
 * Project: Books-App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 8, 2020.
 * Description: Assignment - Books-App
 * https://github.com/maasantos10/
 ************************************************************/


import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

import backgroundImg from '../../assets/backgroundBooks.jpg';

export const Background = styled.div`
  background: url(${backgroundImg}) center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
    
`;

export const Container = styled.div`
  height: 95vh;
  display: flex;
  align-items: stretch;
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 10px;
`;

export const ScrollContent = styled.div`
  position: relative;
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 10px;
  height:560px; 
  width:100%;
  overflow:hidden;
  overflow-y:scroll;
  
`;

export const Content = styled.div`

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 100%;
  margin-bottom: 2px;
  //border: 1px solid lightgreen;
  
  border: 1px solid gray;
  border-radius: 20px;
  background-color: #000000;
  background: rgba(0, 0, 0, 0.7);
`;

const showupFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  

  animation: ${showupFromLeft} 1s;

  //border: 1px solid lightgreen;

  

  form {
    margin: 5px 0;
    width: 340px;
    text-align: center;

    h1 {
      margin-bottom: 10px;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, '#F4EDE8')};
      }
    }
  }

  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;

    display: flex;
    align-items: center;

    svg {
      margin-right: 16px;
    }

    &:hover {
      color: ${shade(0.2, '#ff9000')};
    }
  }
`;
